// Assets/imp-model-qf.js
(function () {
  function norm(s) {
    return (s || "").toString().trim().toUpperCase();
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      const args = arguments;
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function init(el) {
    const input = el.querySelector("[data-imp-qf-input]");
    const list = el.querySelector("[data-imp-qf-list]");
    const meta = el.querySelector("[data-imp-qf-meta]");
    const panel = el.querySelector("[data-imp-qf-panel]");
    const btn = el.querySelector(".imp-qf-btn");
    const basePath = el.getAttribute("data-imp-basepath") || "/collections/";
    const limit = parseInt(el.getAttribute("data-imp-limit") || "60", 10);

    const models = Array.isArray(window.IMP_MODELS) ? window.IMP_MODELS.slice() : [];
    const modelsNorm = models.map(function (m) {
      return { raw: m, n: norm(m) };
    });

    let activeIndex = -1;
    let currentLinks = [];

    function openPanel() {
      panel.classList.add("is-open");
    }

    function closePanel() {
      panel.classList.remove("is-open");
      activeIndex = -1;
      currentLinks = [];
    }

    function setActive(idx) {
      const items = list.querySelectorAll(".imp-qf-item");
      items.forEach(function (i) {
        i.classList.remove("is-active");
      });

      if (idx >= 0 && idx < items.length) {
        items[idx].classList.add("is-active");
        items[idx].scrollIntoView({ block: "nearest" });
      }
    }

    function render(matches, q) {
      list.innerHTML = "";

      if (!q) {
        meta.textContent = "Type a model number to see matches.";
        closePanel();
        return;
      }

      openPanel();

      if (!matches.length) {
        meta.textContent = "0 Matching Models";
        list.innerHTML = '<div class="imp-qf-empty">No matches found.</div>';
        currentLinks = [];
        return;
      }

      meta.textContent = matches.length + " Matching Models";
      const frag = document.createDocumentFragment();
      currentLinks = matches.map(function (m) {
        return basePath + encodeURIComponent(m.toLowerCase());
      });

      matches.forEach(function (m, i) {
        const a = document.createElement("a");
        a.className = "imp-qf-item";
        a.href = currentLinks[i];
        a.textContent = m;
        a.addEventListener("mouseenter", function () {
          activeIndex = i;
          setActive(activeIndex);
        });
        frag.appendChild(a);
      });

      list.appendChild(frag);
      activeIndex = -1;
    }

    const run = debounce(function () {
      const q = norm(input.value);

      if (!q) {
        render([], "");
        return;
      }

      const starts = [];
      const contains = [];

      for (let i = 0; i < modelsNorm.length; i++) {
        const item = modelsNorm[i];

        if (item.n.startsWith(q)) {
          starts.push(item.raw);
        } else if (item.n.indexOf(q) !== -1) {
          contains.push(item.raw);
        }

        if (starts.length + contains.length >= limit) break;
      }

      render(starts.concat(contains), q);
    }, 60);

    input.addEventListener("input", run);

    input.addEventListener("focus", function () {
      if (input.value.trim()) {
        run();
      }
    });

    input.addEventListener("keydown", function (e) {
      const items = list.querySelectorAll(".imp-qf-item");

      if (e.key === "ArrowDown") {
        if (!panel.classList.contains("is-open") || !items.length) return;
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        setActive(activeIndex);
      } else if (e.key === "ArrowUp") {
        if (!panel.classList.contains("is-open") || !items.length) return;
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        setActive(activeIndex);
      } else if (e.key === "Enter") {
        const q = norm(input.value);

        if (activeIndex >= 0 && activeIndex < currentLinks.length) {
          e.preventDefault();
          window.location.href = currentLinks[activeIndex];
          return;
        }

        const exact = modelsNorm.find(function (x) {
          return x.n === q;
        });

        if (exact) {
          e.preventDefault();
          window.location.href = basePath + encodeURIComponent(exact.raw.toLowerCase());
        }
      } else if (e.key === "Escape") {
        closePanel();
      }
    });

    if (btn) {
      btn.addEventListener("click", function () {
        const q = norm(input.value);
        if (!q) return;

        const exact = modelsNorm.find(function (x) {
          return x.n === q;
        });

        if (exact) {
          window.location.href = basePath + encodeURIComponent(exact.raw.toLowerCase());
          return;
        }

        const first = list.querySelector(".imp-qf-item");
        if (first) {
          window.location.href = first.href;
        }
      });
    }

    document.addEventListener("click", function (e) {
      if (!el.contains(e.target)) closePanel();
    });
  }

  function boot() {
    document.querySelectorAll("[data-imp-qf]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();